import { TexturesNames } from '../types'

/**
 * Specialny konfig pre sponzorov v hre
 */
export const sponsorsConfig = {

  // bannery
  banners: [

    {
      name: 'vshosting',
      textureName: TexturesNames.colorGradientVshosting,
      textureNameScreens: TexturesNames.screensVshosting,
      active: true,
      times: [

        {
          from: 1722463200000, // 1.8.2024
          to: 1723672800000, // 15.8.2024
          percent: 0.1 // 10%
        },
        {
          from: 1723672800000, // 15.8.2024
          to: 1724882400000, // 29.8.2024
          percent: 0.3 // 30%
        },
        {
          from: 1727301600000, // 26.9.2024
          to: 1728511200000, // 10.10.2024
          percent: 0.1 // 10%
        }

      ]
    }

  ]

}
